import apiClient from './apiConfig';

export interface Reward {
  id: number;
  name: string;
  description: string;
  points_cost: number;
  is_active: boolean;
  stock?: number;
  image?: string;
  image_url?: string;
  created_at: string;
  updated_at: string;
}

export interface RewardsResponse {
  success: boolean;
  data: Reward[];
  message: string;
}

/**
 * Get all rewards
 */
export const getAllRewards = async (): Promise<Reward[]> => {
  const response = await apiClient.get<RewardsResponse>('/rewards');
  return response.data.data;
};

/**
 * Get a single reward by ID
 */
export const getRewardById = async (id: number): Promise<Reward> => {
  const response = await apiClient.get(`/rewards/${id}`);
  return response.data.data;
};

/**
 * Create a new reward
 */
export const createReward = async (formData: FormData): Promise<Reward> => {
  const response = await apiClient.post('/rewards', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data.data;
};

/**
 * Update an existing reward
 */
export const updateReward = async (id: number, formData: FormData): Promise<Reward> => {
  const response = await apiClient.post(`/rewards/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data.data;
};

/**
 * Delete a reward
 */
export const deleteReward = async (id: number): Promise<void> => {
  await apiClient.delete(`/rewards/${id}`);
};

const rewardService = {
  getAllRewards,
  getRewardById,
  createReward,
  updateReward,
  deleteReward,
};

export default rewardService;
